import jwtDecode from 'jwt-decode';
import { sortBy } from 'lodash';
import { createContext, ReactNode, useCallback, useLayoutEffect, useMemo, useState } from 'react';

import { IsSuperAdmin } from 'src/components/guards/PermissionsList';
import { AUTH_TOKEN } from 'src/config';
import { AuthContextValue, User } from 'src/types/auth';
import { Companies } from 'src/types/Companies';
import axios from '../utils/axios';
import { getUserCompanyDetails } from '../utils/transformation';
export const AuthContext = createContext<AuthContextValue>({} as AuthContextValue);

type AuthProviderProps = {
  children: ReactNode;
};

interface CompanyFromMessage {
  companyId: number;
  companyName: string;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [tokenFromMessage, setTokenFromMessage] = useState('');
  const [companiesFromMessage, setCompaniesFromMessage] = useState<Companies>([]);
  const messageHandler = useCallback((event: MessageEvent<string>) => {
    try {
      const data: { jwt: string; companies?: CompanyFromMessage[] } = JSON.parse(event.data);
      if (data.jwt) {
        setTokenFromMessage(data.jwt);
        setCompaniesFromMessage(
          data.companies?.map((company) => ({
            companyId: company.companyId.toString(),
            companyName: company.companyName,
          })) || []
        );
      }
    } catch (error) {}
  }, []);

  useLayoutEffect(() => {
    window.addEventListener('message', messageHandler);

    return () => window.removeEventListener('message', messageHandler);
  }, [messageHandler]);

  const [
    user,
    companies,
    token,
    loggedInCompanyId,
    companyId,
    isShuster,
    companyName,
    isSuperAdmin,
  ] = useMemo(() => {
    const token = tokenFromMessage || AUTH_TOKEN;
    const user: User = token ? jwtDecode(token) : ({ LocaleId: '1033' } as User);
    const companies: Companies = user?.Companies?.length
      ? sortBy(getUserCompanyDetails(user), ['companyName'])
      : companiesFromMessage;
    const loggedInCompanyId = user?.LoggedInCompanyId;
    const companyName = user?.CompanyName || '';
    const companyId = user?.CompanyId;
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    const isShuster = user?.SiteID === '126';
    const isSuperAdmin = !!user?.Role?.includes(IsSuperAdmin[0]);
    console.log('companies', companies);
    return [
      user,
      companies,
      token,
      loggedInCompanyId,
      companyId,
      isShuster,
      companyName,
      isSuperAdmin,
    ];
  }, [companiesFromMessage, tokenFromMessage]);

  return (
    <AuthContext.Provider
      value={{
        user,
        companies,
        token,
        loggedInCompanyId,
        companyId,
        isShuster,
        companyName,
        isSuperAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
